import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
const defaultOptions = {} as const;

export type CreateVehicleCargoItemMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateVehicleCargoItemInput;
}>;

export type CreateVehicleCargoItemMutationResult = { __typename?: 'Mutation' } & {
  cargoCreateVehicleCargoItem?: GraphQLTypes.Maybe<
    { __typename?: 'CreateVehicleCargoItemPayload' } & {
      cargoItem?: GraphQLTypes.Maybe<
        | ({ __typename?: 'CargoContainerType' } & Pick<GraphQLTypes.CargoContainerType, 'id'>)
        | ({ __typename?: 'CargoLooseCargoType' } & Pick<GraphQLTypes.CargoLooseCargoType, 'id'>)
        | ({ __typename?: 'CargoVehicleType' } & Pick<GraphQLTypes.CargoVehicleType, 'id'>)
      >;
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const CreateVehicleCargoItemDocument = /*#__PURE__*/ gql`
  mutation createVehicleCargoItem($input: CreateVehicleCargoItemInput!) {
    cargoCreateVehicleCargoItem(input: $input) {
      cargoItem {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useCreateVehicleCargoItemMutation__
 *
 * To run a mutation, you first call `useCreateVehicleCargoItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicleCargoItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehicleCargoItemMutation, { data, loading, error }] = useCreateVehicleCargoItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVehicleCargoItemMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateVehicleCargoItemMutationResult, CreateVehicleCargoItemMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<CreateVehicleCargoItemMutationResult, CreateVehicleCargoItemMutationVariables>(
    CreateVehicleCargoItemDocument,
    options
  );
}
export type CreateVehicleCargoItemMutationHookResult = ReturnType<typeof useCreateVehicleCargoItemMutation>;
